import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber6 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm.527 3.89-.183.007c-1.997 0-3.263 1.646-3.34 4.039L5 8.17a4.675 4.675 0 0 0 .695 2.626 2.722 2.722 0 0 0 2.39 1.247 2.56 2.56 0 0 0 2.719-2.66 2.36 2.36 0 0 0-2.278-2.51l-.182.001a2.038 2.038 0 0 0-1.89 1.149l-.065.147h-.035v-.2c0-1.66.707-2.908 1.978-2.908a1.452 1.452 0 0 1 1.364.873l.049.127 1.035-.682a2.456 2.456 0 0 0-2.253-1.49zm-.501 4.104a1.368 1.368 0 0 1 1.437 1.303l-.001.145a1.369 1.369 0 0 1-1.436 1.448 1.36 1.36 0 0 1-1.401-1.448 1.36 1.36 0 0 1 1.4-1.448z" />
    </g>
  );
};

export default withIcon(IconNumber6);
